module.exports = __webpack_public_path__ + "assets/img/icon_nextplay.d04a772d.svg";